export default __webpack_public_path__ + "static/media/regular.32ce538b.svg";